package com.example.hukakmp.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.example.hukakmp.data.PescadexCatalog
import com.example.hukakmp.viewmodel.FishCounterViewModel

@Composable
fun FishCounterScreen(
    uiState: FishCounterViewModel.UiState,
    onAdd: (String, Int) -> Unit,
    onIncrement: (String) -> Unit,
    onDecrement: (String) -> Unit,
    onReturned: (String, Int) -> Unit,
    onRemove: (String) -> Unit,
    onClear: () -> Unit,
    onCreateReport: () -> Unit,
    onBack: () -> Unit,
) {
    var search by remember { mutableStateOf("") }
    var quantity by remember { mutableIntStateOf(1) }

    val speciesNames = remember {
        PescadexCatalog.species.map { it.nombreComun }.distinct().sorted()
    }
    val filtered = remember(search) {
        if (search.isBlank()) emptyList()
        else speciesNames
            .filter { it.contains(search, ignoreCase = true) }
            .take(6)
    }
    val validSpecies = speciesNames.firstOrNull { it.equals(search.trim(), ignoreCase = true) }

    Scaffold(
        containerColor = MaterialTheme.colorScheme.background,
        topBar = {
            TopAppBar(
                navigationIcon = {
                    TextButton(onClick = onBack) {
                        Text("‹", color = MaterialTheme.colorScheme.onPrimary, fontSize = 30.sp)
                    }
                },
                title = {
                    Column {
                        Text("Contador", fontWeight = FontWeight.Bold)
                        Text(
                            "Contá primero, cargá el parte después",
                            style = MaterialTheme.typography.labelSmall,
                            color = MaterialTheme.colorScheme.onPrimary.copy(alpha = 0.76f),
                        )
                    }
                },
                actions = {
                    HukaLogoMark(
                        modifier = Modifier.padding(end = 16.dp).size(32.dp),
                        tint = MaterialTheme.colorScheme.onPrimary,
                    )
                },
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = MaterialTheme.colorScheme.primary,
                    titleContentColor = MaterialTheme.colorScheme.onPrimary,
                ),
            )
        },
    ) { padding ->
        LazyColumn(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .padding(horizontal = 16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            item {
                Surface(
                    modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                    shape = RoundedCornerShape(20.dp),
                    color = MaterialTheme.colorScheme.primaryContainer,
                ) {
                    Column(modifier = Modifier.padding(18.dp)) {
                        Text(
                            "Tu conteo rápido",
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.Bold,
                        )
                        Text(
                            "${uiState.totalFish} ${if (uiState.totalFish == 1) "pez" else "peces"}" +
                                if (uiState.totalReturned > 0) " · ${uiState.totalReturned} devueltos" else "",
                            color = MaterialTheme.colorScheme.primary,
                            fontWeight = FontWeight.Bold,
                            fontSize = 22.sp,
                            modifier = Modifier.padding(top = 4.dp),
                        )
                    }
                }
            }

            item {
                Surface(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(18.dp),
                    color = MaterialTheme.colorScheme.surface,
                    shadowElevation = 1.dp,
                ) {
                    Column(modifier = Modifier.padding(16.dp)) {
                        Text("Agregar captura", fontWeight = FontWeight.Bold)

                        OutlinedTextField(
                            value = search,
                            onValueChange = { search = it },
                            label = { Text("Especie") },
                            placeholder = { Text("Ej: Pejerrey") },
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth().padding(top = 10.dp),
                            shape = RoundedCornerShape(14.dp),
                        )

                        if (filtered.isNotEmpty() && validSpecies == null) {
                            Surface(
                                modifier = Modifier.fillMaxWidth(),
                                shape = RoundedCornerShape(12.dp),
                                color = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.55f),
                            ) {
                                Column {
                                    filtered.forEach { species ->
                                        Text(
                                            species,
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .clickable { search = species }
                                                .padding(horizontal = 12.dp, vertical = 9.dp),
                                        )
                                    }
                                }
                            }
                        }

                        Row(
                            modifier = Modifier.fillMaxWidth().padding(top = 12.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween,
                        ) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                OutlinedButton(
                                    onClick = { if (quantity > 1) quantity-- },
                                    enabled = quantity > 1,
                                ) { Text("−") }
                                Text(
                                    quantity.toString(),
                                    fontSize = 22.sp,
                                    fontWeight = FontWeight.Bold,
                                    modifier = Modifier.padding(horizontal = 16.dp),
                                )
                                OutlinedButton(onClick = { if (quantity < 99) quantity++ }) {
                                    Text("+")
                                }
                            }

                            Button(
                                onClick = {
                                    validSpecies?.let {
                                        onAdd(it, quantity)
                                        search = ""
                                        quantity = 1
                                    }
                                },
                                enabled = validSpecies != null,
                            ) {
                                Text("Agregar")
                            }
                        }
                    }
                }
            }

            item {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Text("Tus capturas", fontWeight = FontWeight.Bold)
                    if (uiState.entries.isNotEmpty()) {
                        TextButton(onClick = onClear) { Text("Limpiar todo") }
                    }
                }
            }

            if (uiState.entries.isEmpty()) {
                item {
                    Surface(
                        modifier = Modifier.fillMaxWidth().height(150.dp),
                        shape = RoundedCornerShape(18.dp),
                        color = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.35f),
                    ) {
                        Column(
                            modifier = Modifier.fillMaxSize(),
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.Center,
                        ) {
                            Text("🎣", fontSize = 40.sp)
                            Text(
                                "Todavía no agregaste capturas",
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                            )
                        }
                    }
                }
            } else {
                items(uiState.entries, key = { it.name }) { entry ->
                    Surface(
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(16.dp),
                        color = MaterialTheme.colorScheme.surface,
                        shadowElevation = 1.dp,
                    ) {
                        Column(modifier = Modifier.padding(14.dp)) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                verticalAlignment = Alignment.CenterVertically,
                            ) {
                                Text(
                                    entry.name,
                                    modifier = Modifier.weight(1f),
                                    fontWeight = FontWeight.Bold,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis,
                                )
                                OutlinedButton(onClick = { onDecrement(entry.name) }) { Text("−") }
                                Text(
                                    entry.count.toString(),
                                    fontWeight = FontWeight.Bold,
                                    modifier = Modifier.padding(horizontal = 10.dp),
                                )
                                OutlinedButton(onClick = { onIncrement(entry.name) }) { Text("+") }
                                Spacer(Modifier.width(6.dp))
                                TextButton(onClick = { onRemove(entry.name) }) {
                                    Text("Quitar", color = MaterialTheme.colorScheme.error)
                                }
                            }

                            Row(
                                modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                                verticalAlignment = Alignment.CenterVertically,
                            ) {
                                Text(
                                    "Devueltos",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                                    modifier = Modifier.weight(1f),
                                )
                                OutlinedButton(
                                    onClick = { onReturned(entry.name, entry.returned - 1) },
                                    enabled = entry.returned > 0,
                                ) { Text("−") }
                                Text(
                                    "${entry.returned}/${entry.count}",
                                    modifier = Modifier.padding(horizontal = 10.dp),
                                    fontWeight = FontWeight.SemiBold,
                                )
                                OutlinedButton(
                                    onClick = { onReturned(entry.name, entry.returned + 1) },
                                    enabled = entry.returned < entry.count,
                                ) { Text("+") }
                            }
                        }
                    }
                }
            }

            item {
                Button(
                    onClick = onCreateReport,
                    enabled = uiState.entries.isNotEmpty(),
                    modifier = Modifier.fillMaxWidth().height(54.dp),
                    shape = RoundedCornerShape(16.dp),
                ) {
                    Text(
                        if (uiState.entries.size == 1) {
                            "Crear parte con 1 especie"
                        } else {
                            "Crear parte con ${uiState.entries.size} especies"
                        },
                        fontWeight = FontWeight.Bold,
                    )
                }
                Spacer(Modifier.height(18.dp))
            }
        }
    }
}
